import { BOTH_TYPE, IN_PERSON_TYPE } from './misc/consts';

export const formatedDay = (date) => formatedDate(date, { day: 'numeric' });

export const formatedWeekday = (date) =>
  formatedDate(date, { weekday: 'long' });

export const formatedMonth = (date) => formatedDate(date, { month: 'long' });

export const formatedYear = (date) => formatedDate(date, { year: 'numeric' });

export const formatedDate = (date, options = {}) => {
  let fomatedDate = new Date(date);
  return fomatedDate.toLocaleDateString(locale(), options);
};

export const locale = () => document.documentElement.lang;

export const stopScrolling = () => {
  document.body.classList.add('stop-scrolling');
};

export const formatedMoney = (czk) => {
  return `${parseInt(czk).toLocaleString(locale())} Kč`;
};

export const startScrolling = () =>
  document.body.classList.remove('stop-scrolling');

export const truncateString = (string = '', maxLength = 50) =>
  string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;

export const tcDays = (duration, customDuration) => {
  if (customDuration > 0) {
    if (customDuration === 1) {
      return `${duration} hodina`;
    }
    if (customDuration > 1 && customDuration <= 4) {
      return `${customDuration} hodiny`;
    }
    return `${customDuration} hodin`;
  }
  if (duration === 1) {
    return `${duration} den`;
  }
  if (duration > 1 && duration <= 4) {
    return `${duration} dny`;
  }
  return `${duration} dnů`;
};

export const formatedPlace = (event_type, city) => {
  if (event_type === BOTH_TYPE) {
    return `<strong>Online</strong> <small>nebo</small> <strong>${city}</strong>`;
  } else if (event_type === IN_PERSON_TYPE) {
    return `<strong> ${city} </strong>`;
  } else {
    return '<strong>Online</strong>';
  }
};
